<template>
    <div class="fixed z-index-fixed bottom-0 left-0 w-screen">
        <div class="wrapper-menubar bg-white">
            <div class="grid grid-cols-5">
                <div :class="{'bg-blue-1' : pageActive == 'home'}" @click="clickTab('/home')">
                    <div class="flex pt-3">
                        <img class="m-auto h-8" v-if="pageActive == 'home'" src="@/assets/iconmenu/ic-privilege-active.svg" alt="" />
                        <img class="m-auto h-8" v-else src="@/assets/iconmenu/ic-privilege-inactive.svg" alt="" />
                    </div>
                    <div class="text-18 text-center pt-2 h-11 leading-4"
                        :class="{'text-white' : pageActive == 'home', 'text-blue-1' : pageActive != 'home'}"
                        >สิทธิพิเศษ
                        </div>
                </div>
                <div :class="{'bg-blue-1' : pageActive == 'reward'}" @click="clickTab('/reward')">
                    <div class="flex pt-3">
                        <img class="m-auto h-8" v-if="pageActive == 'reward'" src="@/assets/iconmenu/ic-reward-active.svg" alt="" />
                        <img class="m-auto h-8" v-else src="@/assets/iconmenu/ic-reward-inactive.svg" alt="" />
                    </div>
                    <div class="text-18 text-center pt-2 h-11 leading-4"
                        :class="{'text-white' : pageActive == 'reward', 'text-blue-1' : pageActive != 'reward'}"
                        >รีวอร์ด
                        </div>
                </div>
                <div :class="{'bg-blue-1' : pageActive == 'history'}" @click="clickTab('/history')">
                    <div class="flex pt-3">
                        <img class="m-auto h-8" v-if="pageActive == 'history'" src="@/assets/iconmenu/ic-history-active.svg" alt="" />
                        <img class="m-auto h-8" v-else src="@/assets/iconmenu/ic-history-inactive.svg" alt="" />
                    </div>
                    <div class="text-18 text-center pt-2 h-11 leading-4"
                        :class="{'text-white' : pageActive == 'history', 'text-blue-1' : pageActive != 'history'}"
                        >ประวัติ<br/>
                        การใช้งาน
                        </div>
                </div>
                <div :class="{'bg-blue-1' : pageActive == 'activity'}" @click="clickTab('/activity')">
                    <div class="flex pt-3">
                        <img class="m-auto h-8" v-if="pageActive == 'activity'" src="@/assets/iconmenu/ic-activity-active.svg" alt="" />
                        <img class="m-auto h-8" v-else src="@/assets/iconmenu/ic-activity-inactive.svg" alt="" />
                    </div>
                    <div class="text-18 text-center pt-2 h-11 leading-4"
                        :class="{'text-white' : pageActive == 'activity', 'text-blue-1' : pageActive != 'activity'}"
                        >กิจกรรม
                        </div>
                </div>
                <div :class="{'bg-blue-1' : pageActive == 'other'}" @click="clickTab('/other')">
                    <div class="flex pt-3">
                        <img class="m-auto h-8" v-if="pageActive == 'other'" src="@/assets/iconmenu/ic-other-active.svg" alt="" />
                        <img class="m-auto h-8" v-else src="@/assets/iconmenu/ic-other-inactive.svg" alt="" />
                    </div>
                    <div class="text-18 text-center pt-2 h-11 leading-4"
                        :class="{'text-white' : pageActive == 'other', 'text-blue-1' : pageActive != 'other'}"
                        >เมนูอื่นๆ
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
//mixin
import ConfigManager from "@/config/ConfigManager";
import AuthStatusMixin from "@/mixin/AuthStatusMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import { StaticLevel,UserLevel } from "@/core/UserLevel/UserLevelDetail.js";

export default {
    name: "MenuBar",
    mixins: [AuthStatusMixin,LocaleMixin],
    inject: ['SideMenuStore'],
    props: {
        modalController: Object,
    },
    data: function() {
        return {
            pageActive: this.$route.name,
        };
    },
    methods: {
        clickTab: function (path) {
            if (path == '/activity'|| path =='/reward' || path =='/history'){
                if(this.isLogin){
                    let level = this.getLevelText();
                    if(path == '/activity' && !level) {
                        this.modalController.confirmModal
                                            .clearModal()
                                            .setTag('verifiedlaserno')
                                            .setMsg(this.lbl.verify_laser_id.before_redeem)
                                            .setBtnOk(this.lbl.verify_laser_id.confirm_btn)
                                            .show()
                        this.modalController.confirmModal.onClickOk(() => {
                            let url = `${ConfigManager.getWebSofinUrl()}/editinfo?return_url=${this.$route.path.substring(1,this.$route.path.length)}`
                            window.location.replace(url);
                        });
                    } else {
                        this.$router.push(path);
                    }
                } else {
                    this.modalController.alertModal
                        .clearModal()
                        .setMsg(this.lbl.redeem_button.alert_login_msg)
                        .setBtnOk(this.lbl.redeem_button.alert_ok_btn)
                        .show();

                    this.modalController.alertModal
                        .onClickOk(() => {
                            let url = ConfigManager.getWebSofinUrl();
                            window.location.replace(url);
                        });
                }
            } else {
                this.$router.push(path);
            }
        },
        getLevelText: function () {
            if (this.isLogin) {
                this.level = {...StaticLevel};
                this.userLevel = new UserLevel();
                return this.userLevel.getLevelVerifiedlaserno();
            } else {
                return "";
            }
        },
    },
}
</script>
